<!--
  功能：审计平台类详情页面
  cyz
  邮箱：cyz@126.com
  时间：2023年03月01日 10:36:19
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="audit-container" style="margin: 0;paddding:0;height: 500px;width: 100%;">
        <div class="audit-img">
            <div class="audit-title">
                <h1>审计平台类</h1>
                <h5>远程审计工具（审计指挥舱）、经济责任审计智能评分平台、智慧审计平台，实现整个审计作业流程的全面管理，工单及底稿的管理，问题检查点管理，审计程序等内容。</h5>
            </div>
            <!-- <img :src="require(`@/assets/img/sjzl-1.png`)" style="width: 100%;height: 100%;"/> -->
        </div>
        <div class="data-box">
            <div class="audit-scene">
                <h2>应用场景</h2>
                <span>智慧审计、领导干部经责审计、基于数字孪生的风控</span>
            </div>
            <div class="audit-pointer">
              <div class="audit-theme">
                    <div class="theme-box">
                      <div class="theme-mwx">
                        <div class="theme-svg">
                          <div class="fsize iconfont" style="color: #eb8585;">&#xe602;</div>
                        </div>
                        <div class="theme-area">
                          <h3>智慧审计</h3>
                        </div>
                        <div class="theme-description">
                          远程审计、审计指挥舱、审计项目管理
                        </div>
                      </div>
                    </div>
                    <div class="theme-box">
                      <div class="theme-mwx">
                        <div class="theme-svg">
                          <div class="fsize iconfont" style="color: #64b1ec;">&#xe610;</div>
                        </div>
                        <div class="theme-area">
                          <h3>领导干部经责审计</h3>
                        </div>
                        <div class="theme-description">
                          经济责任审计、领导干部智能评价、评价系统、画像系统
                        </div>
                      </div>
                    </div>
                    <div class="theme-box">
                      <div class="theme-mwx">
                        <div class="theme-svg">
                          <div class="fsize iconfont" style="color: #ede69f;">&#xe748;</div>
                        </div>
                        <div class="theme-area">
                          <h3>基于数字孪生的风控</h3>
                        </div>
                        <div class="theme-description">
                          企业全局风险展示、企业风险矩阵、企业风险高层价值展示
                        </div>
                      </div>
                    </div>
              </div>
              <div class="contact-us">
                  <div class="contact-box">
                      <div class="contact-img">
                          <div class="img-box"></div>
                          <div class="img-box"></div>
                          <div class="img-box"></div>
                      </div>
                      <div class="contact-go">
                          <h3>了解更多</h3>
                          <div class="more">联系我们以了解更多的场景</div>
                      </div>
                      <div class="contact-href">
                        <a href="javascript:;"><router-link to="/contact">联系我们<i class="el-icon-right"></i></router-link></a>
                      </div>
                  </div>
              </div>
            </div>
            <div class="audit-scene">
              <h2>产品靓点</h2>
              <span>远程审计、按需审计、审计指挥舱、智能化远程审计工具和平台</span>
            </div>
            <div class="audit-light">
                <div class="light-left">
                    <img src="../../../assets/img/product/auditplat.png"/>
                </div>
                <div class="light-right">
                      <div class="lr-content">
                          <p class="rect">远程审计按需审计，由持续风险监控和评估输出结果触发</p>
                          <p class="rect">审计项目指挥舱</p>
                          <p class="rect">审计项目管理系统：审计项目底稿、疑点工单管理、疑点核实工单一键生成、疑点核实工单追踪反馈、审计底稿一键生成等，审计项目疑点的下发、核实、反馈的相关流程，达到审计成果应用最大化</p>
                      </div>
                </div>
            </div>
        </div>
        <div class="audit-result">
          <img src="../../../assets/img/product/cx11.png"/>
        </div>
    </div>
</template>

<script>
export default {
  // 组件名称
  name: 'AuditPlatform',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {}
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  created () {
  },

  mounted () {
  },
}
</script> 
<style lang="less" scoped>
 .audit-container{
        width: 100%;
        height: auto;
        .audit-img{
            width: 100%;
            height: 450px;
           // background-color: #001847;
           background-image: linear-gradient(to bottom right,#32496d,#001847);
            position: relative;
            float:left;
            .audit-title{
                position: absolute;
                z-index: 999;
                left:10%;
                top:35%;
                h1{
                    font-size: 64px;
                    color:#fff;
                    font-weight: inherit;
                    padding: 0;
                    margin:0;
                }
                h5{
                    font-size: 24px;
                    color: #fff;
                    font-weight: inherit;
                    
                }
            }
            /* img{
                width:100%;
                height:400px;
                opacity: 1;          
              } */
        }
        .data-box{
            width: calc(100% - 280px);
            height:auto;
            margin:0 140px 0 140px;
            float:left;
            .audit-scene{
              width: 100%;
              height: 220px;
              float:left;
              position: relative;
              display: flex;
              justify-content:center;
              h2{
                position: absolute;
                color: #001847;
                font-size: 36px;
                line-height: 36px;
                font-weight: inherit;
                bottom:40px;
              }
              span{
                position: absolute;
                color: #4c6686;
                font-size: 20px;
                line-height: 36px;
                font-weight: inherit;
                bottom:15px;
              }
            }
            .audit-pointer{
              width:100%;
              height:auto;
              float:left;
              margin:20px 0 20px 0;
              display:flex;
              justify-content:center;
              align-items: center;
              .audit-theme{
                width:calc(100% - 250px);
                height: 320px;
                display:flex;
                justify-content:flex-start;
                .theme-box{
                  width: calc(calc(100% / 3) - 10px);
                  height: 100%;
                  margin-right:10px;
                  .theme-mwx{
                    width: calc(100% - 1.25rem);
                    height:100%;
                    margin-right:20px;
                    .theme-svg{
                      width: 100%;
                      height:140px;
                      position: relative;
                      .fsize{
                        position: absolute;
                        font-size:100px;
                        bottom:15px;
                        font-weight:400;
                      }
                    }
                  .theme-title{
                    width: 100%;
                    height:auto;
                    float:left;
                    font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
                    h3{
                      color: #001847;
                      font-size: 24px;
                      line-height: 28px;
                      font-weight:inherit;
                      background-color:#000;
                    }

                  }
                  .theme-description{
                    width: calc(100% - 30px);
                    height: 20px;
                    float: left;
                    margin-right: 30px;
                    font-size: 16px;
                    color: #4c6686;
                  }
                  } 
                }
              }
              .contact-us{
                width: 250px;
                height: 320px;
                background-color: #2456c7;
                .contact-box{
                  width: calc(100% - 40px);
                  height:calc(100% - 40px);
                  margin:20px 20px 20px 20px;
                  float: left;
                  position: relative;
                  .contact-img{
                    width: 100%;
                    height: 45px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 20px;
                    .img-box{
                       width: 10px;
                       height:10px;
                       border:2px solid #fff;
                       border-radius:50%;
                       margin-right:10px;
                    }
                  }
                  .contact-go{
                      width: 100%;
                      height: auto;
                      text-align:center;
                      color:#fff;
                      h3{
                        font-size: 24px;
                        line-height: 36px;
                      }
                      .more{
                        text-align: center;
                        margin-top: 12px;
                      }
                  }
                  .contact-href{
                    width:100%;
                    height:24px;
                    line-height:24px;
                    text-align: center;
                    position:absolute;
                    bottom:10%;
                    a{
                      color:#fff;
                      font-size:14px;
                    }
                    a:hover{
                      color:#000;
                      
                    }
                  }
                }
              }
            }
          .audit-light{
            width: 100%;
            height: auto;
            float: left;
            .light-left{
              width: 65%;
              height:480px;
              float:left;
              img{
                width: 95%;
                height: 460px;
              }
            }
            .light-right{
              width: 35%;
              height: auto;
              float: left;
              .lr-content{
                margin: 0px 5px 0px 5px;
                width:calc(100% - 10px);
                height:100%;
                float:left;
                .rect{
                  position: relative;
                  padding-left: 15px;
                  width:80%;
                  height:auto;
                  padding-top: 20px;
                  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
                  font-size: 16px;
                  color: #4c6686;
                  }
                  .rect::before{
                      z-index: 999;
                      content: "";
                      position: absolute;
                      top: 25px;
                      left: 0;
                      height: 12px;
                      width: 12px;
                      background-color: #53cac6;
                  }
              }
            }
          }
        }
        .audit-result{
            width: 100%;
            height: auto;
            float:left;
            img{
              width: 100%;
              height:100%;
              background-color: #001847;
            }
          }
    }
</style>
